import {
  BadgeOutlineMediumIcon,
  ButtonInlineSmall,
  ButtonWrapper,
  CardMembership,
  ChangeOutlineMediumIcon,
  Section,
  token,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { useCardMembershipContracts } from '../home.store';
import styled from '@emotion/styled';
import { CardMembershipModal } from './CardMembershipModal';

export const CardMembershipSection = () => {
  const {
    hasContract,
    isLoading,
    selectedContract,
    hasMultipleContracts,
    shouldShowDependentsButton,
    handleGoToDependents,
    contractsWithRoles,
    handleSelectContract,
    isOpen,
    setIsOpen,
  } = useCardMembershipContracts();

  if (!hasContract && !isLoading) return null;
  if (!selectedContract) return null;

  return (
    <>
      <Section>
        <CardMembership
          plan={selectedContract?.plan_group_name}
          name={selectedContract?.fullname}
          beneficiary={selectedContract?.beneficiary}
          category={selectedContract?.category_name}
          code={selectedContract?.customer_code}
        />
        <Container>
          {hasMultipleContracts && (
            <ButtonWrapper onClick={() => setIsOpen(true)}>
              <ButtonInlineSmall icon={<ChangeOutlineMediumIcon />}>
                Exibir outro plano
              </ButtonInlineSmall>
            </ButtonWrapper>
          )}
          {shouldShowDependentsButton && (
            <LinkWrapper href={handleGoToDependents}>
              <ButtonInlineSmall icon={<BadgeOutlineMediumIcon />}>
                Ver dependentes
              </ButtonInlineSmall>
            </LinkWrapper>
          )}
        </Container>
      </Section>

      <CardMembershipModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        handleSelectContract={handleSelectContract}
        contractsWithRoles={contractsWithRoles}
      />
    </>
  );
};

const Container = styled.div`
  display: flex;
  gap: ${token.spacing.spacingSmall};
`;
